import { TeamRepository } from '../repositories';

export class CancelTeamInvitationUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(invitationId: string): Promise<void> {
    await this.teamRepository.updateInvitationStatus(invitationId, 'cancelled');
  }
}
